import { React, useEffect, useState } from "react";
import img_flor_flora from "../../../assets/images/img_flor_flora.png";
import VideoGroupsBanner from "../../../components/videoGroupsBanner";
import ico_hoja from "../../../assets/icons/ico_hoja.svg";
import GroupInfoSection from "../../../components/groupInfoSection";
import GoToPage from "../../../components/goToPage";
import GroupsVideoFooter from "../../../components/groupsVideoFooter";
const FloraScreen = ({ handle }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const bosque = "https://drive.google.com/uc?export=download&id=1tIJ6tOcvie2j2X2iOU0YxDypFkzvSFX0";

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);

  return (
    <div className="bg-[#002E0F] h-full">
        {width > 1300 ? (
        <div>
<div className="grid overflow-hidden lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 lg:grid-rows-1  gap-0 w-full h-full bg-[#002E0F] absolute">
          <div className="relative w-full lg:h-full">
          <VideoGroupsBanner videoSource={bosque} left="10%" />
          <div className="h-full bg-[#002E0F] bottom-0 right-0 absolute z-30 pl-24 pt-10 pr-36">
            <GoToPage
              page="/grupos"
              side="left"
              name="Atrás"
              fontsize="text-lg"
              textColor="text-white"
              borderType="border-b-2"
              borderColor="border-white"
              iconSize="h-4"
              iconColor="invert"
              iconMargin="mr-5"
            ></GoToPage>
          </div>
          <img
          
            src={img_flor_flora}
            alt=""
            className="w-full bottom-0 absolute z-40"
          />
        </div>

        <GroupInfoSection
          webvrurl="https://niv3.vercel.app/"
          icon={ico_hoja}
          title={<p>Flora</p>}
          subTitle=""
          textFirstTab={
            <p>
              La flora es el conjunto de todas las especies de plantas de un área determinada. En el caso de todos los grupos descritos, un complemento fundamental para el abordaje es conocer la diversidad florística mediante un inventario.

            </p>
          }
          textSecondTab={
            <p>
              Un inventario florístico es fundamental al inicio del proyecto de monitoreo como parte del estudio de línea base. Con el inventario florístico podemos obtener la información necesaria para explicar muchas de las razones por las cuales encontramos especies determinadas de aves, murciélagos y mamíferos, entre otros grupos.
            </p>
          }
          textThirdTab={
            <p>
              Reductos de bosques primarios, bosques secundarios, bosques de
              galería y toda la flora arbórea característica de un lugar o sitio
              de interés.
            </p>
          }
        ></GroupInfoSection>
      </div>
        </div>
        ):(
            <div className="min-h-[100vh] grid grid-cols-1 h-full">
            <div className=" bg-[#002E0F] left-0  lg:pl-24 md:pl-10 sm:pl-10 pl-10 pt-32 pr-36 h-fit">
              <GoToPage
                page="/grupos"
                side="left"
                name="Atrás"
                fontsize="text-lg"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-4"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>
            <div style={{"z-index":"1"}}>
            <GroupInfoSection
          webvrurl="https://niv3.vercel.app/"
          icon={ico_hoja}
          title={<p>Flora</p>}
          subTitle=""
          textFirstTab={
            <p>
              La flora es el conjunto de todas las especies de plantas de un área determinada. En el caso de todos los grupos descritos, un complemento fundamental para el abordaje es conocer la diversidad florística mediante un inventario.

            </p>
          }
          textSecondTab={
            <p>
              Un inventario florístico es fundamental al inicio del proyecto de monitoreo como parte del estudio de línea base. Con el inventario florístico podemos obtener la información necesaria para explicar muchas de las razones por las cuales encontramos especies determinadas de aves, murciélagos y mamíferos, entre otros grupos.
            </p>
          }
          textThirdTab={
            <p>
              Reductos de bosques primarios, bosques secundarios, bosques de
              galería y toda la flora arbórea característica de un lugar o sitio
              de interés.
            </p>
          }
        ></GroupInfoSection>
            </div>
            <div className="relative w-full lg:h-full flex justify-center">
              <GroupsVideoFooter videoSource={bosque} />
             
              <img
              
                src={img_flor_flora}
                alt=""
                className="w-full h-full bottom-0 absolute "
              />
            </div>
          </div>
        )}
      
    </div>
  );
};

export default FloraScreen;
